import { ModulesMap } from '@/config/data/modulesMaps'
import WorksStaffPaymentRatesNormsApi from '@/services/apiServiceModules/worksStaffPaymentRatesNormsApi'
import DataTransferModule from '@/services/dataTransferModule'

const worksStaffPaymentRatesNormsApi = new WorksStaffPaymentRatesNormsApi()

export default class WorksStaffPaymentRatesNormsDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.WORKS_STAFF_PAYMENT_RATES_NORMS, worksStaffPaymentRatesNormsApi, {
			useCache: true,
		})
	}
}
